import { render, staticRenderFns } from "./vip.vue?vue&type=template&id=2bd14160&scoped=true"
import script from "./vip.vue?vue&type=script&lang=js"
export * from "./vip.vue?vue&type=script&lang=js"
import style0 from "./vip.vue?vue&type=style&index=0&id=2bd14160&prod&lang=less&scoped=true"
import style1 from "./vip.vue?vue&type=style&index=1&id=2bd14160&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd14160",
  null
  
)

export default component.exports